import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import Url from '../utils/url';
import env from '../env';
var pageRegxs = {
  dpPage: /ping.com\/app/,
  showDetail: /\/show-detail/,
  showList: /\/show-ticket/,
  showIndex: /\/(my|movie)show\/index/
}; // 生产环境

var isProduct = env.isProduct; // 这里可能需要做分平台处理逻辑

var Ad = /*#__PURE__*/function () {
  function Ad(url) {
    _classCallCheck(this, Ad);

    ['dianping://web?url=', 'imeituan://www.meituan.com/web?url=', 'meituanmovie://www.meituan.com/web?url='].forEach(function (protocal) {
      // 协议地址weburl需要剥离
      if (url.indexOf(protocal) === 0) {
        url = decodeURIComponent(url.split(protocal)[1]);
      }
    });
    this.url = url;

    var _Url$parse = Url.parse(url),
        uri = _Url$parse.uri,
        hash = _Url$parse.hash,
        query = _Url$parse.query;

    this.uri = uri;
    this.query = query || {};
    this.hash = hash;
  }

  _createClass(Ad, [{
    key: "pageType",
    get: function get() {
      var _this = this;

      if (!pageRegxs.dpPage.test(this.uri)) {
        return {
          dpPage: false,
          otherPage: true
        };
      } else {
        var types = {};
        Object.keys(pageRegxs).forEach(function (str) {
          var name = str.charAt(0).toUpperCase() + str.slice(1);
          types[str] = pageRegxs[str].test(_this.uri);
        });
        return types;
      }
    }
  }, {
    key: "landingPage",
    get: function get() {
      // 广告位 落地页 具体地址
      var _this$pageType = this.pageType,
          dpPage = _this$pageType.dpPage,
          showDetail = _this$pageType.showDetail,
          showList = _this$pageType.showList,
          showIndex = _this$pageType.showIndex;
      var _this$query = this.query,
          id = _this$query.id,
          data = _this$query.data,
          key = _this$query.key; // 自带协议地址直接返回

      if (showDetail) {
        // 详情页
        var performanceId = id || data;
        id && delete this.query.id;
        data && delete this.query.data;
        return Url.stringify('/myshow/index.html', this.query, "/detail/".concat(performanceId));
      }

      if (showList) {
        // 列表页
        return;
      }

      if (showIndex) {
        // 首页
        return this.url;
      } // 默认直接返回url


      return this.url;
    }
  }]);

  return Ad;
}();

export { Ad as default };